/* eslint @typescript-eslint/no-explicit-any: 0 */

abstract class Serializer<T> {
    abstract serialize(obj: T): any;
    abstract deserialize(data: any): T;

    deserializeList(data: any[]): T[] {
        return data.map((item) => this.deserialize(item));
    }
}

export default Serializer;
